import { postApi, getApi, deleteApi, patchApi } from "@/store/api/api";
import { Action } from "@/store/actionType";
import { pathReplacer } from "@/utils/router.utils";

export default new (class mmc_staff_list_API {
  public async getMmcStaffList(query: any): Promise<any> {
    const url = `${Action.MMCMembersStaff}`;
    const response = await getApi(url, query);
    return response;
  }
  public async getMmcStaffById(id: number): Promise<any> {
    const url = pathReplacer(Action.MMCMembersStaffDetails, [
      { name: "<id>", value: id },
    ]);
    const response = await getApi(url);
    return response;
  }
  public async getPaginatedMmcStaff(query: any): Promise<any> {
    const url = `${Action.PaginatedMMCMembersStaff}`;
    const response = await getApi(url, query);
    return response;
  }
  public async createMmcStaff(data: FormData): Promise<any> {
    const url = `${Action.MMCMembersStaff}`;
    const response = await postApi(url, data, {
      "Content-Type": "multipart/form-data",
    });
    return response;
  }
  public async editMmcStaff(data: FormData, id: number): Promise<any> {
    const url = pathReplacer(Action.MMCMembersStaffDetails, [
      { name: "<id>", value: id },
    ]);
    const response = await patchApi(url, data, {
      "Content-Type": "multipart/form-data",
    });
    return response;
  }
  public async deleteMmcStaff(id: number): Promise<any> {
    const url = pathReplacer(Action.MMCMembersStaffDetails, [
      { name: "<id>", value: id },
    ]);
    const response = await deleteApi(url, "");
    return response;
  }
})();
